import * as Sentry from '@sentry/browser'
import { useMutation } from '@tanstack/react-query'
import {
  CreateTemplateV3Body,
  InlineResponse2004,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  HTTPError,
  handleHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { store } from 'src/state/store'

export const useMutationCreateTemplateV3 = () => {
  return useMutation<InlineResponse2004, HTTPError, CreateTemplateV3Body>({
    mutationFn: async body => {
      return await baseClient
        .getApi(TemplatesApi)
        .createTemplateV3({ createTemplateV3Body: body })
        .catch(e => {
          Sentry.captureException(e, {
            extra: {
              requestBody: body,
              templateState: store.getState().templatesState,
            },
          })
          return handleHTTPError(e)
        })
    },
  })
}
